'use client';

import { useIsDesktopSideMenu } from '@/widgets/side-menu/model/hooks/useIsDesktopSideMenu';
import { SideMenuDynamic } from '@/widgets/side-menu/dynamic';

const DesktopSideMenu = () => {
  const isDesktop = useIsDesktopSideMenu();

  if (!isDesktop) return null;

  return <SideMenuDynamic />;
};

export { DesktopSideMenu };
